import { TaggedError } from "../tagged-error.js";
export class EmailInUseError extends TaggedError {
    constructor() {
        super("EmailInUseError");
    }
}
